import React from 'react';
import Fieldset from './Fieldset';
import Textarea, { type TextareaProps } from './Textarea';

export interface TextareaFieldsetProps extends TextareaProps {
  id: string;
  htmlFor: string;
  fieldsetClassName?: string;
}

const TextareaFieldset = React.forwardRef<HTMLTextAreaElement, TextareaFieldsetProps>(
  (
    {
      id,
      htmlFor,
      fieldsetClassName,
      className = '',
      label,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      ...props
    },
    ref
  ) => {
    return (
      <Fieldset id={id} htmlFor={htmlFor} fieldsetClassName={fieldsetClassName}>
        <Textarea
          id={id}
          ref={ref}
          className={className}
          label={label}
          hint={hint}
          hintClassName={hintClassName}
          hintId={hintId}
          hintHidden={hintHidden}
          {...props}
        />
      </Fieldset>
    );
  }
);

TextareaFieldset.displayName = 'TextareaFieldset';

export default TextareaFieldset;
